import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-container mt-5">
      <div className="footer-content">
        <div className="footer-info">
          <h2>
            <a
              style={{ color: '#fff' }}
              href="https://www.crystalandco.co.uk/"
              target="_blank"
              rel="noreferrer"
            >
              Crystal&Co{' '}
            </a>
          </h2>
          <p>
            <a href="tel:02086167727" className="footer-link">
              0208 616 7727
            </a>
          </p>

          <p>
            <a
              href="mailto:info@crystalandco.co.uk"
              target="_blank"
              rel="noreferrer"
              className="footer-link"
            >
              info@crystalandco.co.uk
            </a>
          </p>
          <p>12 College Road, HA1 1BE</p>
          <div className="footer-icons">
            <a
              href="https://www.facebook.com/Crystalandcouk/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-facebook"></i>
            </a>
            <a
              href="https://www.instagram.com/crystalandco2015/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-instagram"></i>
            </a>
            <a
              href="https://uk.linkedin.com/company/crystal-co"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-brands fa-linkedin"></i>
            </a>
          </div>
          <a
            href="https://www.crystalandco.co.uk/privacy-policy"
            target="_blank"
            rel="noreferrer"
            className="footer-link"
          >
            Privacy Policy
          </a>

          <p>
            © {new Date().getFullYear()} All Rights Reserved <br />
            Crystal&Co UK Ltd is a Limited company registered in England and
            Wales. <br />
            Registration number: 09672329
          </p>
        </div>
        <div className="footer-map-container">
          <div className="footer-map">
            <iframe
              title="Google Map"
              src="https://maps.google.com/maps?hl=en&amp;q=12 College Rd, Harrow HA1 1BE, UK&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              width="100%"
              height="200"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <div className="footer-hours">
            <h4>Working hours:</h4>
            <p>Monday - Friday: 09:00 - 17:30</p>
            <p>Saturday & Sunday: 09:00 - 17:00</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
